var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#1e1405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.95-254.31q54.9-36.84 111.64-57.63 56.74-20.78 124.41-20.78 67.67 0 124.49 20.78 56.82 20.79 111.72 57.63 42.02-45.05 65.98-101.87Q806.15-413 806.15-480q0-136.38-94.88-231.27-94.89-94.88-231.27-94.88t-231.27 94.88Q153.85-616.38 153.85-480q0 67 24.03 123.82 24.04 56.82 66.07 101.87Zm235.93-208.77q-50.26 0-84.59-34.44-34.32-34.45-34.32-84.71 0-50.26 34.45-84.58 34.44-34.32 84.7-34.32 50.26 0 84.59 34.45 34.32 34.44 34.32 84.7 0 50.26-34.45 84.58-34.44 34.32-84.7 34.32ZM479.73-120q-74.89 0-140.67-28.04-65.78-28.04-114.46-76.99-48.68-48.94-76.64-114.27T120-480.33q0-75.19 28.04-140.78 28.04-65.58 76.99-114.2 48.94-48.61 114.27-76.65Q404.63-840 480.33-840q75.19 0 140.78 28.04 65.58 28.04 114.2 76.65 48.61 48.62 76.65 114.31Q840-555.31 840-480.18q0 75.65-28.04 140.93t-76.65 114.22q-48.62 48.95-114.4 76.99Q555.14-120 479.73-120Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.7f9d26bce92264bd.svg";
export { ForwardRef as ReactComponent };